import { useEffect, useCallback } from 'react';
import { config } from '@/utils';

type Props = {
  callback?: any;
};

const useBaseUrlChange = ({ callback }: Props) => {
  const baseUrl = config.get('baseUrl');

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (baseUrl) {
      window.addEventListener('hashchange', callback);

      return () => {
        window.removeEventListener('hashchange', callback);
      };
    }
  }, [callback]);

  return useCallback(
    (value: string) => {
      if (!baseUrl) return;
      const cleanBaseUrl = baseUrl.replace('/#/', '').replace(/[/]$/g, '');
      window.history.pushState(
        {},
        '',
        `${cleanBaseUrl}${value ? `-${value.toLocaleLowerCase()}` : ''}/${
          value ? window.location.hash : '#/'
        }`
      );
      window.location.reload();
    },
    [baseUrl]
  );
};

export default useBaseUrlChange;
